import React from "react";
import i18n from "../../../i18n";
import { withNamespaces } from "react-i18next";

import { Label, Container, Col, Form, Button, Row } from "reactstrap";
import { Input } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { openNotification } from "../Components/Notification/index.js";
import imagenLogin from "./../../../resources/fondo-login-xpdconnect.jpg";
import { Services } from "../../../repositories/clients/Services.js";

import Authentication from "../../../services/Authentication.js";
import SessionStorage from "../../../services/SessionStorage";
import { SetNewListGroups } from "../../../state/actions/Header";
import { isMobile, getBrowserInfo } from "../../utils/userAgent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import logo from "./../../../resources/logo-xpdconnect-blanco.svg";

const auth = new Authentication();
const dt = new Date();
const BackgroundHead = {
  backgroundImage: `url(${imagenLogin})`,
  backgroundSize: "cover",
  backgroundPosition: "bottom",
};
/*=============================================
=            Login Component                  =
=============================================*/
function Login(props) {
  const paramssso = props.match.params.id;
  var activesso = false;

  if (paramssso !== undefined) {
    activesso = true;
  }

  const [redirectlogin, setRedirectlogin] = React.useState({
    login: {
      email: localStorage.getItem("email") ? localStorage.getItem("email") : "",
      valid: false,
      password: localStorage.getItem("password")
        ? localStorage.getItem("password")
        : "",
      check: localStorage.getItem("email") ? true : false,
    },
  });
  let [password, setPassword] = React.useState(false);
  const [recoverPassword, setrecoverPassword] = React.useState("");
  const [response, setresponse] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [activessoValidate, setActivessoValidate] = React.useState(activesso);
  const [hashsso, setHashsso] = React.useState(paramssso);
  const [showPass, setShowPass] = React.useState(false);

  /*=============================================
  =            Handle Login Function            =
  =============================================*/
  function change(event) {
    document.getElementById("email_sin").setAttribute("hidden", "hidden");
    document.getElementById("pass_sin").setAttribute("hidden", "hidden");
    document.getElementById("error_user").setAttribute("hidden", "hidden");

    if (event.target.name === "email") {
      let value = event.target.value.toLowerCase();
      const emailRegex = new RegExp(/^\S+@\S+\.\S+$/);
      if (emailRegex.test(value)) {
        redirectlogin.login.valid = true;
        document.getElementById("email_alert").setAttribute("hidden", "hidden");
      } else {
        redirectlogin.login.valid = false;
        document.getElementById("email_alert").removeAttribute("hidden");
      }
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    } else {
      let value = event.target.value;
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    }
  }

  function changeCorreo(event) {
    document.getElementById("correo_alert").removeAttribute("hidden");
    document
      .getElementById("correo_alert_base")
      .setAttribute("hidden", "hidden");
    document.getElementById("correo_sin").setAttribute("hidden", "hidden");
    let value = event.target.value;
    const emailRegex = new RegExp(/^\S+@\S+\.\S+$/);
    if (emailRegex.test(value)) {
      document.getElementById("correo_alert").setAttribute("hidden", "hidden");
      document.getElementById("correo_aler_button").removeAttribute("hidden");
    } else {
      document.getElementById("correo_alert").removeAttribute("hidden");
      document
        .getElementById("correo_aler_button")
        .setAttribute("hidden", "hidden");
    }
    setrecoverPassword(value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    handleLoginId();
  }

  async function handleLoginId() {
    try {
      setLoading(true);
      const { email, password, check } = redirectlogin.login;

      if (!email || !password) {
        setErrorVisibility("email_sin", !email);
        setErrorVisibility("pass_sin", !password);
        setLoading(false);
        return;
      }

      setErrorVisibility("email_sin", false);
      setErrorVisibility("pass_sin", false);

      const authData = { email, password };
      const authResponse = await axios.post(
        `${Services.ADMIN.path}oauth/setAuthentication`,
        authData
      );

      if (authResponse.data.login) {
        const token = authResponse.data.token;
        const userData = authResponse.data.data?.[0];
        const id = userData.UserId;
        const lang = userData.Code;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const rolId = authResponse.data.rolId;

        if (check) {
          localStorage.setItem("email", email);
          localStorage.setItem("password", password);
        }

        const groupsResponse = await axios.get(
          `${Services.ADMIN.path}admin/customerForId/v2/${id}?zona=${timezone}&lang=${lang}`
        );

        const {
          resp: group_list,
          clients,
          NIT: nit,
          Notify: notify,
        } = groupsResponse.data;

        await props.SetNewListGroups({
          group_list,
          clients,
          nit,
          notify,
          lang,
        });

        const session = new SessionStorage();
        session.addItem("group_list", JSON.stringify(group_list));
        session.addItem("clients", JSON.stringify(clients));
        session.addItem("nit", JSON.stringify(nit));
        session.addItem("notify", JSON.stringify(notify));
        session.addItem("lang", lang);

        auth.setAuthentication(
          token,
          authResponse.data.data,
          group_list,
          email
        );

        if (rolId === 8) {
          await props.history.push("/supplier-management");
        } else {
          await props.history.push("/dashboard");
        }

        setLoading(false);

        sendLoginAudit(id, token);
      } else {
        await props.history.push(`/updatepolicies/${authResponse.data.token}`);
      }
    } catch (error) {
      setLoading(false);
      setErrorVisibility("error_user", true);
      console.error("handleLoginId error:", error);
    }
  }

  function setErrorVisibility(elementId, visible) {
    const el = document.getElementById(elementId);
    if (el) el.hidden = !visible;
  }

  async function sendLoginAudit(userId, sessionId) {
    const Origin = (await isMobile()) ? "Mobile" : "Desktop";
    const browserInfo = await getBrowserInfo();
    const offset = createOffsetValue(new Date());

    const userAudit = {
      UsuarioId: userId,
      SessionId: sessionId,
      StartConnection: new Date(),
      timezone: offset,
      Origin,
      Browser: browserInfo.name,
    };

    axios.post(`${Services.AUDIT.path}user-logs/login`, userAudit);

    /*navigator.sendBeacon(
      `${Services.AUDIT.path}user-logs/login`,
      JSON.stringify(userAudit)
    );*/
  }

  function createOffsetValue(date) {
    const offset = date.getTimezoneOffset();
    const sign = offset > 0 ? "-" : "+";
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
    const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
    return `${sign}${hours}:${minutes}`;
  }

  function handleAccount() {
    if (!recoverPassword) {
      document.getElementById("correo_sin").removeAttribute("hidden");
    } else {
      document.getElementById("correo_sin").setAttribute("hidden", "hidden");
      let data = {
        correo: recoverPassword,
      };

      axios
        .post(`${Services.ADMIN.path}admin/recover`, data)
        .then(() => {
          openNotification("success", props.t("mail_send_successfully"));
          setPassword(false);
          setrecoverPassword("");
        })
        .catch((error) => {
          if (error.response) {
            openNotification("error", props.t(error.response.data.message));
          }
        });
    }
  }

  React.useEffect(() => {
    let navLang = navigator.language || navigator.userLanguage;
    i18n.changeLanguage(navLang.split("-")[0] == "es" ? "MX" : "US");

    if (activessoValidate === true) {
      activeFuntionsso();
    }
  }, []);

  const activeFuntionsso = React.useCallback(async () => {
    console.log("hashsso", hashsso);
    try {
      let data = {
        userIdSso: hashsso,
      };

      const response = await axios.post(
        `${Services.ADMIN.path}oauth/setAuthentication-sso`,
        data
      );

      let token = response.data.token;
      let redirectUserData = response.data.data;

      let id = response.data.data[0].UserId;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const groups = await axios.get(
        `${Services.ADMIN.path}admin/customerForId/v2/${id}?zona=${timezone}&lang=${response.data.data[0].Code}`
      );

      await props.SetNewListGroups({
        group_list: groups.data.resp,
        clients: groups.data.clients,
        nit: groups.data.NIT,
        notify: groups.data.Notify,
        lang: response.data.data[0].Code,
      });

      const session = new SessionStorage();

      session.addItem("group_list", JSON.stringify(groups.data.resp));
      session.addItem("clients", JSON.stringify(groups.data.clients));
      session.addItem("nit", JSON.stringify(groups.data.NIT));
      session.addItem("notify", JSON.stringify(groups.data.Notify));
      session.addItem("lang", response.data.data[0].Code);

      auth.setAuthentication(
        token,
        redirectUserData,
        groups.data.resp,
        redirectlogin.login.email
      );

      await props.history.push("/dashboard");
      setLoading(false);

      const createOffsetValue = (date) => {
        let sign = date.getTimezoneOffset() > 0 ? "-" : "+";
        let offset = Math.abs(date.getTimezoneOffset());
        let hours = Math.floor(offset / 60);
        let minutes = ((offset % 60) / 60) * 10;
        return sign + hours + "." + minutes;
      };

      let Origin = await isMobile();
      let getBrowserInfoAgente = await getBrowserInfo();

      let userAudit = {
        UsuarioId: id,
        SessionId: token,
        StartConnection: new Date(),
        timezone: createOffsetValue(new Date()),
        Origin: Origin ? "Mobile" : "Desktop",
        Browser: getBrowserInfoAgente.name,
      };
      axios.post(`${Services.AUDIT.path}user-logs/login`, userAudit);
      /*navigator.sendBeacon(
        `${Services.AUDIT.path}user-logs/login`,
        JSON.stringify(userAudit)
      );*/
    } catch (error) {
      setLoading(false);
      document.getElementById("error_user").removeAttribute("hidden");

      console.error("handleLoginId", error);
    }
  }, []);

  function funtionRegresa() {
    setPassword(!password);
    setrecoverPassword("");
    document.getElementById("correo_sin").setAttribute("hidden", "hidden");
    document.getElementById("correo_alert").setAttribute("hidden", "hidden");
    document
      .getElementById("correo_alert_base")
      .setAttribute("hidden", "hidden");
    document
      .getElementById("correo_aler_button")
      .setAttribute("hidden", "hidden");
    document.getElementById("correo_exitoso").setAttribute("hidden", "hidden");
  }

  if (redirectlogin.login.check) {
    localStorage.setItem("email", redirectlogin.login.email);
    localStorage.setItem("password", redirectlogin.login.password);
  } else {
    localStorage.removeItem("email", "email");
    localStorage.removeItem("password", "password");
  }

  function showPassword(params) {
    const pdw = document.getElementById("pwd");
    pdw.type = params ? "text" : "password";
    setShowPass(params);
  }

  return (
    <div style={BackgroundHead}>
      <div className="login-page">
        <Container>
          {!password ? (
            <Col
              xs={12}
              md={10}
              lg={6}
              className="ml-auto mr-auto mt-auto mb-5"
            >
              <center className="pb-5">
                <Form onSubmit={handleSubmit}>
                  <img src={logo} alt="now-logo" className="logo-login" />
                  <Col xs={12} md={9} lg={9} className="ml-auto mr-auto">
                    <Input
                      icon="icon-user"
                      iconPosition="left"
                      placeholder={props.t("login_input_user")}
                      type="text"
                      fluid
                      value={redirectlogin.login.email}
                      name="email"
                      onChange={change}
                      className="mb-3 custom-icon-size"
                    />
                    <div id="is-relative">
                      <Input
                        icon="icon-password"
                        iconPosition="left"
                        placeholder={props.t("pass")}
                        id="pwd"
                        type={showPass ? "text" : "password"}
                        fluid
                        value={redirectlogin.login.password}
                        name="password"
                        onChange={change}
                        className="custom-icon-size"
                      />
                      <span
                        id="icon-eye"
                        onClick={() => setShowPass(!showPass)}
                      >
                        <i
                          className={
                            showPass
                              ? "icon-password-see eye-pass"
                              : "icon-password-unsee eye-pass"
                          }
                        />
                      </span>
                    </div>
                    <div
                      className="_alert"
                      id="email_alert"
                      hidden
                      style={{
                        textAlign: "center",
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                    >
                      {props.t("valid_email")}
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                      className="_alert"
                      id="email_sin"
                      hidden
                    >
                      {props.t("user_pass_invalid")}
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                      className="_alert"
                      id="pass_sin"
                      hidden
                    >
                      {props.t("pass_required")}
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                      className="_alert"
                      id="error_user"
                      hidden
                    >
                      {props.t("user_pass_invalid")}
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() => {
                            redirectlogin.login.check =
                              !redirectlogin.login.check;
                            setRedirectlogin({
                              redirectlogin,
                              ...redirectlogin,
                            });
                          }}
                          checked={redirectlogin.login.check}
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 28 },
                            color: "blue",
                            "&.Mui-checked": { color: "blue" },
                          }}
                        />
                      }
                      label={props.t("remember_pass")}
                      sx={{
                        color: "#fdfdfd",
                        fontWeight: "bold",
                        "& .MuiTypography-root": {
                          fontSize: 12,
                          fontFamily: "SF Pro Display",
                        },
                        fontFamily: "SF Pro Display",
                      }}
                    />
                    <Col xs={6} md={9} lg={9} className="ml-auto mr-auto">
                      <Button
                        type="submit"
                        color="primary"
                        block
                        disabled={loading}
                      >
                        {loading ? props.t("getting_access") : props.t("login")}
                      </Button>
                    </Col>
                    <Label className="cant_sign_in pt-3">
                      <b>{props.t("cant_sign_in")}</b>
                    </Label>
                    <Label
                      className="forgot_pass pb-3"
                      onClick={() => {
                        setPassword(!password);
                      }}
                    >
                      <b>{props.t("forgot_pass")}</b>
                    </Label>
                  </Col>
                  <div className="_terminos">
                    <ul className="terms-links">
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={props.t("private_policy_url")}
                        >
                          {props.t("private_policy")}
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={props.t("terms_and_conditions_url")}
                        >
                          {props.t("terms_and_conditions")}
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={props.t("cookie_policy_URL")}
                        >
                          {props.t("cookies_policy")}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="_copy_rigth pb-5">
                    © Copyright {new Date().getFullYear()} xpd global.
                    {props.t("reserved_rights")}
                  </div>
                </Form>
              </center>
            </Col>
          ) : (
            <Col
              xs={12}
              md={10}
              lg={6}
              className="ml-auto mr-auto mt-auto mb-5"
            >
              <center className="pb-5">
                <Form onSubmit={handleSubmit}>
                  <img src={logo} alt="now-logo" className="logo-login" />
                  <Col xs={12} md={9} lg={9} className="ml-auto mr-auto">
                    <div className="pb-4">
                      <span className="legend_recover_pass">
                        {props.t("recover_pass")}
                        <br></br>
                        {props.t("insert_mail")}
                      </span>
                    </div>
                    <Input
                      icon="icon-password"
                      placeholder={props.t("email")}
                      iconPosition="left"
                      fluid
                      id="input_correo"
                      type="text"
                      value={recoverPassword}
                      name="correo"
                      onChange={changeCorreo}
                      className="custom-icon-size"
                    />

                    <div
                      style={{
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                      className="_alert"
                      id="correo_alert"
                      hidden
                    >
                      {props.t("valid_email")}
                    </div>
                    <div
                      style={{
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                      className="_alert"
                      id="correo_alert_base"
                      hidden
                    >
                      {response}
                    </div>
                    <div
                      style={{
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                      className="_alert"
                      id="correo_sin"
                      hidden
                    >
                      {props.t("mail_required")}
                    </div>
                    <div
                      style={{
                        color: "#fdfbfb",
                        fontSize: "12px",
                      }}
                      className="_alert"
                      id="error_correo"
                      hidden
                    >
                      {props.t("mail_is_not_registered")}
                    </div>
                    <div
                      style={{
                        color: "#fdfbfb",
                        fontSize: "14px",
                      }}
                      className="_alert"
                      id="correo_exitoso"
                      hidden
                    >
                      {props.t("mail_send_successfully")}
                    </div>
                    <Row className="mt-4">
                      <Col xs={6} className="ml-auto mr-auto">
                        <Button
                          block
                          color="secondary"
                          onClick={funtionRegresa}
                        >
                          {props.t("back")}
                        </Button>
                      </Col>
                      <Col xs={6} className="ml-auto mr-auto">
                        <Button
                          block
                          color="primary"
                          id="correo_aler_button"
                          onClick={handleAccount}
                        >
                          {props.t("send")}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Form>
              </center>
            </Col>
          )}
        </Container>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  SetNewListGroups: (new_group_list) =>
    dispatch(SetNewListGroups(new_group_list)),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Login))
);
